import SynchronousMotors from "../classes/SynchronousMotor"

export const synchronousMotors = [
  new SynchronousMotors({alias:"acometida", svgSrc: "/symbol-assets/Acometida.svg", label: "Label for Type 1"}),
  new SynchronousMotors({alias:"arco", svgSrc: "/symbol-assets/Arco.svg", label: "Label for Type 2"}),
  new SynchronousMotors({alias:"condensador", svgSrc: "/symbol-assets/Condensador.svg", label: "Label for Type 3"}),
];
